/* CogniGum V12: kleine Ergänzungen zum Aussehen. Kauf-Logik bleibt in cg-pdp.js und im Dawn-Warenkorb. */
(function () {
  'use strict';
  var d = document;
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function init() {
    /* Startseite: Paketwahl im Angebotsblock (nur Anzeige, der Button führt zur Produktseite) */
    var box = d.querySelector('[data-v12-offer]');
    var setOffer = null;
    if (box) {
      var L = box.querySelectorAll('#ofL li');
      var q = function (s) { return box.querySelector(s); };
      var set = function (el) {
        each(L, function (x) { x.classList.toggle('on', x === el); });
        /* Produktseite: Wahl im Angebotsblock am Seitenende gleich in die Kaufbox übernehmen (Kaufleiste zeigt dann dasselbe Paket) */
        if (box.querySelector('[data-v12-jump]')) {
          var r0 = d.querySelector('[data-cg-offer] input[data-qty="' + el.getAttribute('data-q') + '"]');
          if (r0 && !r0.checked) { r0.checked = true; r0.dispatchEvent(new Event('change', { bubbles: true })); }
        }
        box.classList.add('sw');
        setTimeout(function () {
          var a = el.dataset;
          q('[data-v12-h]').textContent = a.h;
          q('[data-v12-p]').textContent = a.p;
          q('[data-v12-t]').textContent = a.t;
          q('[data-v12-o]').textContent = a.o;
          q('[data-v12-s]').textContent = 'Du sparst ' + a.s;
          q('[data-v12-b]').textContent = 'Angebot sichern · ' + a.t;
          box.classList.remove('sw');
        }, 170);
      };
      setOffer = set;
      each(L, function (el) {
        el.addEventListener('click', function () { set(el); });
        el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); set(el); } });
      });
    }
    /* Produktseite, Angebotsblock am Seitenende: Button springt nach oben zur Paketwahl und wählt dort das
       angeklickte Paket vor. Gekauft wird nur in der Kaufbox (cg-pdp.js reagiert auf das change-Ereignis). */
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var jump = d.querySelector('[data-v12-jump]');
    if (jump) {
      jump.addEventListener('click', function (e) {
        var on = d.querySelector('[data-v12-offer] #ofL li.on');
        var q = on ? on.getAttribute('data-q') : '3';
        var r = d.querySelector('[data-cg-offer] input[data-qty="' + q + '"]');
        if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
        var h = d.querySelector('.rn-pdp .rn-opt-h') || d.getElementById('kaufen');
        if (h) { e.preventDefault(); h.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
      });
    }
    /* Studienseite: sanftes Einblenden beim Scrollen. Ohne JS und bei „Bewegung reduzieren“ bleibt alles sichtbar,
       weil die Klasse rn-rv erst hier gesetzt wird. */
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      each(d.querySelectorAll('[data-rv]'), function (el) {
        if (el.getBoundingClientRect().top > window.innerHeight * 0.9) { el.classList.add('rn-rv'); io.observe(el); }
      });
    }
    /* Produktseite: Paketname in der Kaufleiste und Versandhinweis passend zur Paketwahl */
    var offer = d.querySelector('[data-cg-offer]');
    if (offer) {
      var sync = function () {
        var c = offer.querySelector('input:checked');
        if (!c) return;
        each(d.querySelectorAll('[data-v12-qty]'), function (el) { el.textContent = c.getAttribute('data-label') || ''; });
        /* Angebotsblock am Seitenende zeigt dasselbe Paket wie die Kaufbox */
        if (setOffer && box.querySelector('[data-v12-jump]')) {
          var li = box.querySelector('#ofL li[data-q="' + c.getAttribute('data-qty') + '"]');
          if (li && !li.classList.contains('on')) setOffer(li);
        }
        each(d.querySelectorAll('[data-v12-vat]'), function (el) {
          el.textContent = (+c.getAttribute('data-qty') > 1) ? el.getAttribute('data-multi') : el.getAttribute('data-single');
        });
      };
      offer.addEventListener('change', sync);
      window.addEventListener('pageshow', sync);
      sync();
    }
    /* Bewertungsschnitt mit Komma (4,9) wie im restlichen Shop; der Abschnitt selbst bleibt unverändert */
    each(d.querySelectorAll('.cg-rv__score'), function (el) { el.textContent = el.textContent.replace('.', ','); });
    /* Kaufleiste: Zustand zusätzlich beim Scrollen prüfen. cg-pdp.js schaltet sie über einen IntersectionObserver,
       der bei Sprüngen (Ankerlink „Angebot sichern“ → #kaufen) nicht auslöst. */
    var bar = d.querySelector('[data-cg-sticky]'), atc = d.querySelector('[data-cg-atc]');
    if (bar && atc) {
      var tick = 0, sbtn = bar.querySelector('button');
      var check = function () {
        tick = 0;
        var past = atc.getBoundingClientRect().bottom < 0;
        if (past !== bar.classList.contains('is-on')) {
          bar.classList.toggle('is-on', past);
          bar.setAttribute('aria-hidden', past ? 'false' : 'true');
          if (sbtn) sbtn.tabIndex = past ? 0 : -1;
        }
      };
      window.addEventListener('scroll', function () { if (!tick) tick = requestAnimationFrame(check); }, { passive: true });
    }
    /* V17, Produktseite: Der Link „Produktdetails und Zutaten“ unter den Zutaten-Kacheln (auch von der Startseite
       aus, dann über die Adresse mit #produktdetails) klappt den ersten Aufklapper der Kaufbox auf. */
    var pd = d.getElementById('produktdetails');
    if (pd) {
      var openPd = function () {
        if (location.hash === '#produktdetails') { pd.open = true; pd.scrollIntoView({ block: 'start' }); }
      };
      window.addEventListener('hashchange', openPd);
      each(d.querySelectorAll('a[href$="#produktdetails"]'), function (a) {
        a.addEventListener('click', function () { pd.open = true; });
      });
      openPd();
    }
    /* V21, nur Produktseite: unsichtbare Bestell-Markierung für Besucher aus Google-Anzeigen.
       Aktiv nur, wenn die Adresse utm_source=google und utm_medium=cpc trägt oder utm_content mit „shopping-“ beginnt.
       Dann einmal /cart.js lesen und, wenn der Warenkorb noch kein „lp“ hat, zwei versteckte Felder ins Kaufformular
       setzen (attributes[lp] = utm_content, attributes[gk] = utm_campaign). Sie gehen mit dem normalen Hinzufügen mit
       (Dawn product-form sendet das Formular als FormData). Ohne diese Parameter passiert hier nichts, auch keine Anfrage.
       Kein Cookie, kein Speicher, nichts Sichtbares; ein Fehler hier berührt den Kauf nicht. */
    try {
      var mkForm = d.querySelector('[data-cg-pdp] form[data-type="add-to-cart-form"]');
      if (mkForm && /\/products\/fokus_energie_kaugummi\/?$/.test(location.pathname) && window.URLSearchParams && window.fetch) {
        var mkP = new URLSearchParams(location.search);
        var mkClean = function (v) { return String(v || '').replace(/[^A-Za-z0-9_-]/g, '').slice(0, 60); };
        var mkC = mkP.get('utm_content') || '';
        var mkAds = mkP.get('utm_source') === 'google' && mkP.get('utm_medium') === 'cpc';
        if (mkAds || mkC.indexOf('shopping-') === 0) {
          var mkLp = mkClean(mkC) || 'lp-pdp', mkGk = mkClean(mkP.get('utm_campaign'));
          var mkSet = function (k, v) {
            if (!v || mkForm.querySelector('input[name="attributes[' + k + ']"]')) return;
            var i = d.createElement('input');
            i.type = 'hidden'; i.name = 'attributes[' + k + ']'; i.value = v;
            mkForm.appendChild(i);
          };
          var mkRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(mkRoot + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (c) {
              if (!c) return;
              var a = c.attributes || {};
              if (!a.lp) { mkSet('lp', mkLp); mkSet('gk', mkGk); }
              else if (!a.gk) { mkSet('gk', mkGk); }
            })
            .catch(function () {});
        }
      }
    } catch (mkErr) {}
    /* Menü mobil: mit Escape oder Klick daneben schließen */
    var mm = d.getElementById('cg-menu');
    if (mm) {
      d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mm.open) mm.removeAttribute('open'); });
      d.addEventListener('click', function (e) { if (mm.open && !mm.contains(e.target)) mm.removeAttribute('open'); });
    }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
